import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import EmailTypeList, { DispatchProps, OwnProps, StateProps } from './EmailTypeListScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';

import { getEmailsLogs } from 'src/store/actions/emails-log-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.emailsLog.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getEmailsLogs(params)),
    };
}

const EmailTypeListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(EmailTypeList);

export default EmailTypeListScreen;
